import { getEncodedParams } from 'helpers/encodeParams';

export const siteIOChannelDataEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const siteIOChannelCalloutsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}/callouts?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.siteIOChannelCreativesEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}/creatives?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.siteIOChannelTargetingTacticsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}/targeting?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const siteIOChannelPlacementsEndpoint = (state, params) => {
    const { start, end } = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}/placements?start=${start}&end=${end}`;
}
;
exports.siteIOChannelActivitiesEndpoint = (state, params) => {
    const { start, end } = getEncodedParams(state);

    return `${state.config.apiUrl}/v1/entity/${params.entityId}/site-direct/${params.ioChannel}/activities?start=${start}&end=${end}`;
};

export const siteIOChannelsEndpoint = (state, payload) => {
    const { start, end } = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${payload.entityId}/site-direct/channels?start=${start}&end=${end}`;
};



// WEBPACK FOOTER //
// ./src/services/siteDirect/selectors.js